// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"ba65a85b","604":"a66addd8","712":"a28c7065"}[chunkId] + ".chunk.js";
};